import { cn } from '@/platform/lib/utils';

const colors = {
    gray: 'bg-gray-500 text-white',
    red: 'bg-red-600 text-white',
    orange: 'bg-orange-500 text-white',
    yellow: 'bg-yellow-400 text-white',
    green: 'bg-green-500 text-white',
    blue: 'bg-blue-500 text-white',
    indigo: 'bg-violet-600 text-white',
    purple: 'bg-purple-600 text-white',
    brown: 'bg-neutral-600 text-white',
};

const sizes = {
    sm: 'px-1.5 py-0.5 text-[0.625rem]',
    md: 'px-2 py-0.5 text-xs',
    lg: 'px-2.5 py-1 text-sm',
};

const Badge = ({
    color = 'gray',
    size = 'md',
    className,
    children,
    ...props
}) => (
    <span
        className={cn(
            'inline-flex items-center gap-x-1.5 rounded font-semibold whitespace-nowrap',
            colors[color] ?? colors.gray,
            sizes[size] ?? sizes.md,
            className
        )}
        {...props}
    >
        {children}
    </span>
);

export default Badge;
